import {useContext} from 'react'

import {Context} from '../../Header/Context'

export function LinkComponent({...props}) {
  const {LinkComponent} = useContext(Context)

  return LinkComponent ? <LinkComponent {...props} /> : <a {...props} />
}
